/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {resetPassword} from '../api'

export const useMutationResetPassword = createReactQueryMutationHook('resetPassword', resetPassword)
